import { React, useState } from "react";
import LoginSignupFormInput from "./LoginSignupFormInput";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useContext } from "react";
import { UserContext } from "../context/UserContext";

function LoginSection() {
  const navigate = useNavigate();
  const {setUser} = useContext(UserContext);
  const [loginFormData, setLoginFormData] = useState({
    email: "",
    password: "",
  });

  function handleChange(e) {
    const { name, value } = e.target;

    setLoginFormData((prevLoginFormState) => {
      return {
        ...prevLoginFormState,
        [name]: value,
      };
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = loginFormData;

    try {
      const { data } = await axios.post("/auth/login", { email, password });

      if (data.error) {
        toast.error(data.error)
      } else {
        axios
        .get("/auth/profile")
        .then(({ data }) => {
          setUser(data);          
        })
        .catch((err) => {
          console.log(err);
        });
        
        navigate("/")
      }
    } catch (error) {
      toast.error(error);
    }
  };
  return (
    <section className="login_signup_section">
      <div className="login_signup_container">
        <img
          src="images/login.png"
          alt="personality"
        />

        <form className="login_signup_form" onSubmit={handleSubmit}>
          <h1 className="logo">
                      <NavLink to="/" className="main_logo">
                        <img src="/logo.png" alt="logo" className="logo_image" />
                        {/* <h2>PayoutProphet</h2> */}
                        {/* <div className="logo_text">
                          <span>Asakaaplay</span>
                          <span>Play</span>
                        </div> */}
                      </NavLink>
                    </h1>

          <h2>Log In to your account</h2>

          <LoginSignupFormInput
            label="Email"
            type="email"
            id="email"
            placeHolder="Ex. johndoe@example.com"
            onChange={handleChange}
          />

          <LoginSignupFormInput
            label="Password"
            type="password"
            id="password"
            placeHolder="*************"
            onChange={handleChange}
          />

          <button className="btn btn_login">Log in</button>

          <div>
            <p>Forgot password</p>

            <div className="register">
              <p>Don't have an account?</p>
              <NavLink to={"/signup"}>Register</NavLink>
            </div>
          </div>

          <NavLink to={"/terms"}>Terms and conditions</NavLink>
        </form>

        
      </div>
    </section>
  );
}

export default LoginSection;
